import Fetch from "utils/fetch"

export const saveGeneralSettings = async (data) => {
  await Fetch.patch(`configuracaogeral/atualizar`, data)
}

export const loadGeneralSettings = () => Fetch.get("configuracaogeral/consultar").then((data) => data)
export const loadCompositionIsNewFlow = () => Fetch.get("configuracaogeral/consultar").then((data) => data.data[0].Valor === "0" ? false : true)
export const getGeneralSettings = () => Fetch.get("configuracaogeral/consultar").then(({data}) => data)
export const loadBusinessUnitFeatureFlags = (parameter) => Fetch.get(`business-unit-feature-flags/${encodeURIComponent(parameter)}`)
export const loadBusinessUnitFeatureFlagDefinitions = () => Fetch.get("business-unit-feature-flags")
export const saveBusinessUnitFeatureFlag = (plant, parameter, value) => Fetch.put(`business-unit-feature-flags/${encodeURIComponent(plant)}`, { Parameter: parameter, Value: value })
export const removeBusinessUnitFeatureFlag = (plant, parameter) => Fetch.delete(`business-unit-feature-flags/${encodeURIComponent(plant)}/${encodeURIComponent(parameter)}`)
export const loadOrderCancellationJustifications = () => Fetch.get("orders:cancellation-justifications").then((data) => data)
export const loadSuggestionJustifications = () => Fetch.get("suggestions:justifications").then((data) => data)
